/*
 * @Author: zyb
 * @Date: 2022-03-22 19:04:12
 * @LastEditors: wyj
 * @LastEditTime: 2022-04-29 10:31:31
 * @FilePath: \dev_2.0\src\main.js
 * @Description: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUi from 'element-ui'
import VueLazyload from 'vue-lazyload'  // 引入这个懒加载插件
Vue.use(VueLazyload, { // 添加自定义选项
  // error: '../static/icon/error.png', // 加载错误时候的图片
  loading: '../src/assets/images/lodding.gif', // 加载中的图片
})　　

import './icons'
import "@/assets/common-css/bootstrap.min.css"
//默认css配置
import './assets/styles/index.scss'
import 'element-ui/lib/theme-chalk/index.css'
//轮播图
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

//新闻轮播
import scroll from 'vue-seamless-scroll'
import './assets/styles/element-variables.scss'  //全局改变elment的样式主题
Vue.use(scroll)

//加载动画
import wow from 'wowjs'
import "@/assets/styles/animation.css"
Vue.prototype.$wow=wow
//数字增长插件
import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

Vue.use(ElementUi)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false


//animate
import animated from 'animate.css/animate.css'
Vue.use(animated);



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
